import { Action } from '@ngrx/store';

export enum ActionTypes {
    CHECK_RECORD = '[Media] Record media'
}

export class CheckRecord implements Action {
    readonly type = ActionTypes.CHECK_RECORD;

    constructor(public record : any) { }
}

export type Actions
    = CheckRecord